import { useEffect } from "react";
import { isMainWindow, isTauriRuntime } from "src/lib/runtime/environment";
import { prewarmDocumentWorkspaceWindow } from "src/utilities/openDocumentWorkspace";

/** Keeps an external document workspace ready for the next Tauri preview. */
export function DocumentWorkspaceWindowBridge() {
  useEffect(() => {
    if (!isTauriRuntime() || !isMainWindow()) return;
    void prewarmDocumentWorkspaceWindow().catch((error) =>
      console.warn("Could not prewarm the document workspace window.", error)
    );
  }, []);

  return null;
}
